import { ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

interface FormDialogContainerProps {
  children: ReactNode;
  open: boolean;
  handleClose: () => void;
  title?: ReactNode | null;
  disableBackdropClick?: boolean; 
}

export default function FormDialogContainer({
  children,
  open,
  handleClose,
  title,
  disableBackdropClick = false, 
}: FormDialogContainerProps) {
  return (
    <Dialog
      open={open}
      onClose={disableBackdropClick ? undefined : handleClose} 
      maxWidth="sm"
      fullWidth
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      {children}
    </Dialog>
  );
}
